import React, { useContext } from 'react';
import { AppContext } from 'App.context.js';
import useInvoiceAPIConfigHook from './InvoiceAPI.hook.js';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import styles from './InvoiceAPI.styles.js';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function InvoiceAPI({ pmsNotPermit }) {
  const { state, actions } = useInvoiceAPIConfigHook(pmsNotPermit);
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const infoStyle = styles.apiGoodStyle;

  return (
    <div>
      <div style={{ height: 16 }} />

      <div style={{ height: 16 }}></div>

      <AppButton
        text={translate('policeReport.save')}
        action={async () => {
          const twoFAResult = await show2FAModal();
          if (twoFAResult === true) {
            actions.onSaveFTPConfig();
          }
        }}
        disabled={state.isLoading}
      />
    </div>
  );
}
